import { formatNumber } from '@dec/shared';
import { Card } from 'react-bootstrap';
import {
  Calendar3Week,
  CalendarCheck,
  CalendarEvent,
  CurrencyDollar,
  FileEarmarkText,
  FileSpreadsheet,
  Hourglass
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import env from '../../../../env';
import DateParser from '../../../../utils/date';
import { type OmissionsByTax } from '../types';

import { ViewItem } from './ViewItem';

export const TaxItem = ({ omission }: { omission: OmissionsByTax }) => {
  const { t } = useTranslation();
  const periodLabel = t('non-compliances.label.period');
  //const periodSubLabel = '2022-01';

  const dueDateLabel = t('non-compliances.label.expirationDate');
  //  const dueDateSubLabel = '2022-01';

  const notificationDateLabel = t('non-compliances.label.NotificationDate');
  //const notificationDateSubLabel = '2022-01';

  const presentationDateLabel = t('non-compliances.label.presentationDate');
  //const presentationDateSubLabel = '2022-01';

  const waitLabel = t('non-compliances.label.wait');
  const daysLabel = t('non-compliances.label.days');

  const penaltyLabel = t('non-compliances.label.penalty');
  //const penaltySubLabel = '200.10';

  const amountLabel = t('non-compliances.label.declarationAmount');
  //const amountSubLabel = '62,210.10';

  return (
    <>
      <h2>{omission.taxName}</h2>

      {omission.details.map((detail) => {
        return (
          <>
            <Card className="mb-3">
              <Card.Body>
                <Card.Text>
                  <div className="d-flex justify-content-between flex-wrap">
                    <ViewItem
                      title={periodLabel}
                      subTitle={detail.periodText}
                      icon={FileEarmarkText}
                    />
                    <ViewItem
                      title={dueDateLabel}
                      subTitle={DateParser.toString(detail.dueDate)}
                      icon={CalendarEvent}
                    />
                    <ViewItem
                      title={notificationDateLabel}
                      subTitle={DateParser.toString(detail.notificationDate, '---')}
                      icon={Calendar3Week}
                    />
                    <ViewItem
                      link={
                        detail?.taxreturnId
                          ? `${env.appUrl}/reports/taxreturn/preview/${detail?.taxreturnId}`
                          : undefined
                      }
                      title={presentationDateLabel}
                      subTitle={DateParser.toString(detail.presentationDate, '---')}
                      icon={CalendarCheck}
                    />

                    <ViewItem
                      title={waitLabel}
                      subTitle={detail.days ? `${detail.days} ${daysLabel}` : '---'}
                      icon={Hourglass}
                    />
                    <ViewItem
                      title={penaltyLabel}
                      subTitle={formatNumber(detail.penalty as number)}
                      icon={FileSpreadsheet}
                    />
                    <ViewItem
                      title={amountLabel}
                      subTitle={formatNumber(detail.amount as number)}
                      icon={CurrencyDollar}
                    />
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </>
        );
      })}
    </>
  );
};
